export enum OngoingABTests {
    MULTILEAD_TINDER = "multilead-tinder",
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page"
}
export enum OngoingABTests {
    MULTILEAD_TINDER = "multilead-tinder",
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page"
}
